// import external dependencies
//import $ from 'jquery';




// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_plugins.js";

// import local dependencies
import Router from './util/Router';
import common from './routes/admin/common';
import home from './routes/admin/home';
import aboutUs from './routes/admin/about';

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';

// TODO update to import used icons and not all
// import all icons for dev purposes
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from "@fortawesome/pro-light-svg-icons";

// add the imported icons to the library
library.add(fas,far,fab,fal);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
$(document).ready(() => routes.loadEvents());

// mkdir public/assets/scripts/skins/
// mkdir public/assets/scripts/skins/content
// mkdir public/assets/scripts/skins/content/default
// cp -rf ./node_modules/tinymce/skins/content/default/content.css public/assets/scripts/skins/content/default/content.css
// cp -rf ./node_modules/tinymce/skins/ui/oxide/skin.min.css public/assets/styles/skin.min.css
// cp -rf ./node_modules/tinymce/skins/content/default/content.css /var/www/logicdashboard/public/assets/styles
// cp -rf node_modules/tinymce/skins/content/default/content.min.css /var/www/logicdashboard/public/assets/styles



// WEBPACK FOOTER //
// ./scripts/admin.js